<script lang="ts">
import { getContext } from 'svelte';

import { Icon } from '@viamrobotics/prime-core';

import { useFeatureFlags } from '$lib/api/feature';
import type { AuthState } from '$lib/auth';
import { createInkeepWidget, type InkeepWidget } from '$lib/inkeep';

import DocsMenu from './docs-menu.svelte';
import SupportMenu from './support-menu.svelte';

export interface Props {
  authState: AuthState;
  enableInkeep: boolean;
}

const { authState, enableInkeep }: Props = $props();

const features = useFeatureFlags();
const showAskAI = $derived(enableInkeep && $features.ENABLE_ASK_AI_BUTTON);

let inkeep: InkeepWidget | undefined = $state(undefined);

const initialize = async () => {
  if (authState) {
    inkeep = await createInkeepWidget(authState);
    inkeep?.initialize();
  }
};

$effect.pre(() => {
  void initialize();
});

const openSidebar =
  getContext<(inkeep: InkeepWidget | undefined) => void>('openSidebar');

const handleAskAI = () => {
  openSidebar(inkeep);
};
</script>

<div class="flex items-center gap-4">
  {#if showAskAI}
    <button
      data-inkeep-sidebar-chat-trigger=""
      class="hidden sm:flex h-[34px] items-center gap-1.5 pl-2 pr-3 bg-light hover:bg-medium border"
      onclick={handleAskAI}
    >
      <Icon
        name="ask-ai"
        class="text-gray-7 w-4 h-4"
      />
      <p class="text-xs font-medium whitespace-nowrap">Ask AI</p>
    </button>
  {/if}

  <div class="flex border">
    <div class="border-r">
      <DocsMenu />
    </div>

    <SupportMenu {authState} />
  </div>
</div>
